import { Form } from '@unform/web';
import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.6rem;
`;

export const ConfirmDeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  max-height: 600px;
  overflow-y: auto;
`;

export const ConfirmDeleteTitle = styled.h3`
  font-size: 1.8rem;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
  text-transform: uppercase;
`;

export const Divider = styled.div`
  position: relative;
  width: calc(100% + 60px);
  margin: 0px -30px 10px -30px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const ConfirmDeleteText = styled.p`
  opacity: 0.65;
  margin-bottom: 3.2rem;
`;

export const ConfirmDeleteButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const FormWrapper = styled(Form)``;

export const Side = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Body = styled.div`
  margin: 2rem 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 2rem;
`;

export const InputCheckbox = styled.input``;

export const InputCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const InputCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem;
`;

export const InputCheckboxText = styled.p``;

export const TextareaText = styled.p`
  font-size: 1.4rem;
  font-weight: 700;
  margin: 1rem 0;
  padding: 0 0 0rem 1.2rem;
`;

export const CollaboratorName = styled.h1`
  font-size: 2.8rem;
  font-weight: 700;
`;

export const EditUserInputBlock = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > p {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.black};
    /* opacity: 0.65; */
    font-weight: 700;
    padding: 0 0 0.6rem 1.2rem;
    user-select: none;
  }
`;
